export const QR_CODE_SMS_SUBSCRIBED = 'QR_CODE_SMS_SUBSCRIBED';
